/* eslint-disable @typescript-eslint/naming-convention */
import { takeLatest, call, put } from 'redux-saga/effects';
import { initialize, reset } from 'redux-form';
import { browserHistory } from 'react-router';
import find from 'lodash/find';
import forEach from 'lodash/forEach';
import noop from 'lodash/noop';

import {
  SETTING_PAYMENT_METHODS_PAGE_REQUEST,
  SETTING_PAYMENT_METHODS_ON_CLICK_ACTIVATE_BUTTON,
  SETTING_PAYMENT_METHODS_ON_CLICK_CANCEL_REGISTRATION,
  SETTING_PAYMENT_METHODS_ON_CLICK_SUBMIT_E_WALLET_PAYMENT,
  SETTING_PAYMENT_METHODS_ON_CLICK_SHOW_OUTLET_DETAIL_MODAL,
  SETTING_PAYMENT_METHODS_ON_CLICK_SHOW_TERMS_AND_CONDITIONS_MODAL,
  SETTING_PAYMENT_METHODS_ON_CLICK_ACTIVATE_ALL,
  SETTING_PAYMENT_METHODS_UPDATE_KTP_NPWP,
  SETTING_PAYMENT_METHODS_ON_CLICK_ADD_BANK_ACCOUNT,
  SETTING_PAYMENT_METHODS_ON_CLICK_ADD_BANK_ACCOUNT_OPEN_BANK_ACCOUNT_MODAL,
  SETTING_PAYMENT_METHODS_ON_CLICK_OUTLET_TO_BANK_ACCOUNT,
  SETTING_PAYMENT_METHODS_ON_CLICK_ACTIVATE_PAYMENT_METHOD_IN_NOTIFICATION,
  SETTING_PAYMENT_METHODS_ON_CLICK_DISMISS_PAYMENT_METHOD_IN_NOTIFICATION,
  FETCH_EWALLET,
  SETTING_PAYMENT_METHODS_ACTIVATE_ALL_PAYMENT_METHOD,
  SETTING_PAYMENT_METHODS_REMAINING_PAYMENT_METHOD,
  SETTING_PAYMENT_METHODS_REMAINING_NEW_OUTLET,
} from '../../actions/setting/paymentMethod/constants';
import * as actNotif from '../../actions/notifications';
import * as act from '../../actions';
import * as actBankAcc from '../../actions/setting/bankAccount';
import * as actPaymentMethod from '../../actions/setting/paymentMethod';

import * as apiProfile from '../../api/profile';
import * as apiPaymentMethod from '../../api/paymentMethods';
import * as apiBank from '../../api/bankAccounts';
import * as apiOutlet from '../../api/outlets';
import * as api from '../../api/account';
import * as apiAuth from '../../api/auth';
import * as clevertapSettingsPaymentMethod from '../../clevertap/settings/paymentMethod';
import * as clevertapSettingsPaymentMethods from '../../clevertap/settings/paymentMethods';

function* getBankAccounts() {
  const businessBankAccounts = yield call(apiBank.getAllBackAccounts);
  yield put(
    actPaymentMethod.setBusinessBankAccountList(businessBankAccounts.data)
  );

  // using bank account reducer for handling assign outlet modal
  yield put(actBankAcc.setBankAccountLists(businessBankAccounts.data));
  const outletStatus: any[] = [];
  forEach(businessBankAccounts.data, (bankAcc) => {
    forEach(bankAcc.outlets, (id) => {
      const outlet = {};
      (outlet as any).id = id;
      (outlet as any).bankAccId = bankAcc.business_bank_account_id;
      outletStatus.push(outlet);
    });
  });
  yield put(actBankAcc.setOutletStatus(outletStatus));
  yield put(actPaymentMethod.setAssignedOutlets(outletStatus));
  // end
}

function* fetchUserData() {
  try {
    const resProfile = yield call(apiProfile.getProfile);
    const userData = {
      businessId: resProfile.data.business.id,
      businessName: resProfile.data.business.name,
      userId: resProfile.data.id,
      timestamp: Date.now(),
    };
    return userData;
  } catch (error) {
    return null;
  }
}

function* sendClevertapTrackerOnOpenPaymentMethodPage() {
  try {
    const userData = yield call(fetchUserData);
    if (userData)
      clevertapSettingsPaymentMethod.openPaymentMethodPage(userData);
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(error);
  }
}

function sendClevertapTrackerOpenPage() {
  try {
    clevertapSettingsPaymentMethods.accountSettingsOpenPaymentMethod();
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(error);
  }
}

function sendClevertapTrackerActivePaymentMethod() {
  try {
    clevertapSettingsPaymentMethod.accountSettingsActivePaymentMethod();
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(error);
  }
}

function sendClevertapTrackerSuccessActivateRemainingNewOutlets(payload) {
  try {
    clevertapSettingsPaymentMethod.accountSettingsSuccessActivateRemainingNewOutlets(
      payload
    );
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(error);
  }
}

function sendClevertapTrackerFailActivateRemainingNewOutlets(
  payload,
  errorMessage
) {
  try {
    clevertapSettingsPaymentMethod.accountSettingsFailActivateRemainingOutlets(
      payload,
      errorMessage
    );
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(error);
  }
}

function sendClevertapTrackerSuccessActivateRemainingPaymentMethod(payload) {
  try {
    clevertapSettingsPaymentMethod.accountSettingsSuccessActiveRemainingPaymentMethod(
      payload
    );
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(error);
  }
}

function sendClevertapTrackerFailActivateRemainingPaymentMethod(
  payload,
  errorMessage
) {
  try {
    clevertapSettingsPaymentMethod.accountSettingsFailActivateRemainingPaymentMethod(
      payload,
      errorMessage
    );
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(error);
  }
}

export function* getPaymentMethods() {
  const responsePaymentMethod = yield call(
    apiPaymentMethod.getAllPaymentMethods
  );
  const paymentMethods = responsePaymentMethod.data.map((paymentMethod) => {
    const { code, description, id, name } = paymentMethod;
    return { code, description, id, name };
  });
  yield put(actPaymentMethod.setPaymentMethods(paymentMethods));

  const hashedPaymentMethodOutlet = {};
  responsePaymentMethod.data.forEach((p) => {
    hashedPaymentMethodOutlet[p.id] = p.outlet_statuses;
  });
  yield put(actPaymentMethod.setOutletStatuses(hashedPaymentMethodOutlet));

  yield put(actPaymentMethod.setIsShowRegistrationForm(false));
  yield put(actPaymentMethod.setIsShowPaymentList(true));

  // using bank account reducer for handling assign outlet modal
  const outletStatusPaymentMethod = responsePaymentMethod.data.map(
    (paymentMethod) => {
      const { code, id, outlet_statuses } = paymentMethod;
      return { code, id, outlet_statuses };
    }
  );
  yield put(actBankAcc.setPaymentMethods(outletStatusPaymentMethod));
  yield put(
    actPaymentMethod.setPaymentMethodsOutlets(outletStatusPaymentMethod)
  );
  // end
}

export function* pageRequestFlow() {
  yield put(act.showProgressBar());
  try {
    yield call(getPaymentMethods);
    yield call(sendClevertapTrackerOnOpenPaymentMethodPage);
    yield call(sendClevertapTrackerOpenPage);
    const outletsResponse = yield call(apiOutlet.outlets);
    const allOutlets = outletsResponse.data;
    const outletIds = allOutlets.map((outlet) => outlet.id);
    yield put(actPaymentMethod.setOutlets(allOutlets));
    const { data: walletRegistrationResponse } = yield call(
      apiPaymentMethod.checkWalletRegistration,
      { outletIds }
    );
    const { data: kybStatus } = yield call(apiPaymentMethod.checkKybStatus);
    yield put(actPaymentMethod.setKybStatus(kybStatus.kyb_status));
    yield put(
      actPaymentMethod.setWalletRegistrationStatus(
        walletRegistrationResponse.status
      )
    );
    // using bank account reducer for handling assign outlet modal
    yield put(actBankAcc.setOutlets(allOutlets));
    // end

    const bankList = yield call(apiBank.getAllBanks);
    yield put(actPaymentMethod.setBankList(bankList.data));

    yield call(getBankAccounts);

    // using bank account reducer for handling assign outlet modal
    const multipleBankAccountBankList = bankList.data.map((bank) => {
      const { id, swift_code } = bank;
      const name = bank.bank_name;
      return { id, name, swift_code };
    });
    yield put(actBankAcc.setBankList(multipleBankAccountBankList));
    // end
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error(err);
  } finally {
    yield put(act.hideProgressBar());
  }
}

export function* onClickActivateButtonFlow(request) {
  yield put(actPaymentMethod.setShowOutletDetailModal(false));
  yield put(act.showProgressBar());
  const { userData, businessName, selectedPaymentMethodList } = request.payload;
  yield put(actPaymentMethod.setIsShowRegistrationForm(true));
  yield put(actPaymentMethod.setIsShowPaymentList(false));
  yield put(
    actPaymentMethod.setSelectedPaymentMethodList(selectedPaymentMethodList)
  );
  yield put(
    initialize('paymentRegistration', {
      prefix: 'MK',
      business_name: businessName,
      ktp_number: userData.ktp_number,
      npwp_number: userData.npwp_number,
      ktp_name: userData.ktp_name,
      gravatar: userData.gravatar,
    })
  );

  yield put(act.hideProgressBar());
}

export function* onClickCancelRegistrationFlow() {
  yield put(act.showProgressBar());
  yield put(actPaymentMethod.setIsShowRegistrationForm(false));
  yield put(actPaymentMethod.setIsShowPaymentList(true));
  yield put(actPaymentMethod.setSelectedPaymentMethodList([]));
  yield put(act.hideProgressBar());
}

export function* onClickSubmitEWalletPaymentFlow(request) {
  yield put(act.showProgressBar());
  const { formValue, outlets, business, paymentMethodList } = request.payload;
  const paymentMethodIds = paymentMethodList.map(
    (paymentMethod) => paymentMethod.id
  );

  try {
    const resCategory = yield call(apiAuth.getAllBusinessCategories);
    const businessCategory = find(resCategory.data, {
      id: business.business_category_id,
    });

    const resType = yield call(apiAuth.getBusinessTypes);
    const businessType = find(resType.data, {
      id: businessCategory.business_type_id,
    });

    const outletData = outlets.map((outlet) => {
      const { id, name, address, province, city, postal_code } = outlet;
      return { id, name, address, province, city, postal_code };
    });

    if (!businessType) {
      throw new Error();
    }

    const dataReq = {
      payment_method_ids: paymentMethodIds,
      requirements: {
        KTP_NAME: formValue.ktp_name,
        KTP_NUMBER: formValue.ktp_number,
        NPWP_NUMBER: formValue.npwp_number,
        LATITUDE: business.latitude,
        LONGITUDE: business.longitude,
      },
      business_name: `MK ${formValue.business_name}`,
      business_logo: formValue.gravatar,
      outlets: outletData,
      business_category: businessType.name,
    };

    yield call(apiPaymentMethod.postNewBulkRegistrationPaymentMethods, dataReq);
    yield call(getPaymentMethods);
    yield put(
      actNotif.success(`You have successfully submit payment activation`)
    );
  } catch (e) {
    yield put(
      actNotif.error(`There is an error related to your business category`)
    );
  } finally {
    yield put(act.hideProgressBar());
  }
}

export function* onClickShowOutDetailModalFlow(request) {
  yield put(
    actPaymentMethod.setPaymentMethodKey(request.payload.paymentMethod)
  );
  yield put(actPaymentMethod.setShowOutletDetailModal(true));
}

export function* onClickTermsAndConditionsFlow(request) {
  yield put(
    actPaymentMethod.setPaymentMethodKey(request.payload.paymentMethodKey)
  );
  yield put(actPaymentMethod.setOpenTermsAndConditionsModal(true));
}

export function* onClickActivateAllFlow(request) {
  yield put(act.showProgressBar());
  const { paymentMethodId, outlets, userData } = request.payload;
  const dataReq = {
    payment_method_id: paymentMethodId,
    outlets,
    requirements: {
      KTP_NAME: userData.ktp_name,
      KTP_NUMBER: userData.ktp_number,
      NPWP_NUMBER: userData.npwp_number,
      LATITUDE: userData.business.latitude,
      LONGITUDE: userData.business.longitude,
    },
  };
  yield call(apiPaymentMethod.postNewPaymentMethods, dataReq);
  yield call(getPaymentMethods);
  yield put(actPaymentMethod.setShowOutletDetailModal(false));
  yield put(
    actNotif.success(`You have successfully submit payment activation`)
  );
  yield put(act.hideProgressBar());
}

export function* updateKtpNpwpFlow(request) {
  try {
    const { npwp_number, ktp_number, ktp_name } = request.payload;
    yield call(api.apiSettingAccount, {
      user: { ktp_number, npwp_number, ktp_name },
    });
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error(e);
  }
}

export function* onClickAddBankAccountFlow(request) {
  try {
    const { data, prevBusinessBankAccount } = request.payload;
    const businessBankAccountResponse = yield call(
      apiBank.postNewBankAccount,
      data
    );

    const newBusinessBankAccount = businessBankAccountResponse.data;
    newBusinessBankAccount.outlets = [];

    const newBusinessBankAccountList = [...prevBusinessBankAccount];
    newBusinessBankAccountList.push(businessBankAccountResponse.data);

    yield put(
      actPaymentMethod.setBusinessBankAccountList(newBusinessBankAccountList)
    );
    yield put(actPaymentMethod.setShowBankAccountModalForm(false));
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error(e);
  }
}

export function* onClickAddBankAccountOpenBankAccountModalFormFlow() {
  try {
    yield put(reset('bankAccountModalForm'));
    yield put(actPaymentMethod.setShowBankAccountModalForm(true));
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error(e);
  }
}

export function* linkOutletToBankAccount(request) {
  yield put(actPaymentMethod.hideModalAssignOutletsOnRegistration());
  yield put(act.showProgressBar());
  try {
    const { bank, selectedOutlets, unlinkOutlets } = request.payload;
    const outletData = selectedOutlets.map((outlet) => {
      const { id } = outlet;
      return id;
    });

    const linkOutletReq = {
      business_bank_account_id: bank.bankAccId,
      outlet_ids: outletData,
    };

    yield call(apiBank.linkBankAccountToOutlets, linkOutletReq);

    if (unlinkOutlets !== undefined && unlinkOutlets.length > 0) {
      const unlinkOutletReq = {
        business_bank_account_id: bank.bankAccId,
        outlet_ids: unlinkOutlets,
      };
      yield call(apiBank.unlinkBankAccountFromOutlets, unlinkOutletReq);
      yield put(actPaymentMethod.setUnlinkOutletsModal([]));
    }
    yield call(getBankAccounts);
    yield put(
      actNotif.success('You have successfully assign outlets to bank account.')
    );
  } catch (error) {
    yield put(
      actNotif.error(
        'There is an error, cannot  outlets to bank accounts. Please try again.'
      )
    );
    // eslint-disable-next-line no-console
    console.error(error);
  } finally {
    yield put(act.hideProgressBar());
  }
}

export function* activateAllPaymentMethodSaga(payload, onSuccess, onFail) {
  const { business, outlets } = payload;
  try {
    const { data: kybStatus } = yield call(apiPaymentMethod.checkKybStatus);
    if (kybStatus.is_kyb_complete) {
      if (kybStatus.kyb_status === 'pending') {
        onFail(payload, 'Your KYB is yet to be approved');
        yield put(actNotif.error('Your KYB is yet to be approved'));
        return null;
      }
      if (outlets.length > 0) {
        const { data: bankStatus } = yield call(
          apiPaymentMethod.checkOutletBankStatus
        );
        if (bankStatus.status) {
          const resCategory = yield call(apiAuth.getAllBusinessCategories);
          const businessCategory = find(resCategory.data, {
            id: business.business_category_id,
          });
          const activatePayload = {
            business_name: business.name,
            business_category: businessCategory.name,
            business_logo: business.logo
              ? business.logo.url
              : 'https://s3-ap-southeast-1.amazonaws.com/image.mokapos.com/growth/homepage/index/minimarket.svg',
            outlets: outlets.map((outlet) => ({
              id: outlet.id,
              name: outlet.name,
              address: outlet.address,
              province: outlet.province,
              postal_code: outlet.postal_code,
              city: outlet.city,
            })),
          };
          yield call(
            apiPaymentMethod.activateAllPaymentMethod,
            activatePayload
          );
          yield call(getPaymentMethods);
          yield put(
            actPaymentMethod.setWalletRegistrationStatus(
              'ALL_OUTLET_REGISTERED'
            )
          );
          onSuccess(payload);
        } else {
          onFail(payload, 'You need to assign a bank account to each outlet');
          yield put(actPaymentMethod.setShowBankStatusModal(true));
        }
      } else {
        onFail(payload, 'You do not have any paying outlet');
        yield put(actNotif.error('You do not have any paying outlet'));
      }
    } else {
      onFail(payload, 'kyb is not complete');
      browserHistory.push('/kyb');
    }
  } catch (error) {
    onFail(payload, error);
    yield put(actNotif.error('Something went wrong'));
  }
}

export function* activateAllPaymentMethod(res?) {
  sendClevertapTrackerActivePaymentMethod();
  yield activateAllPaymentMethodSaga(res.payload, noop, noop);
}

export function* activateRemainingPaymentMethod(res?) {
  yield activateAllPaymentMethodSaga(
    res.payload,
    sendClevertapTrackerSuccessActivateRemainingPaymentMethod,
    sendClevertapTrackerFailActivateRemainingPaymentMethod
  );
}

export function* activateRemainingNewOutlet(res?) {
  yield activateAllPaymentMethodSaga(
    res.payload,
    sendClevertapTrackerSuccessActivateRemainingNewOutlets,
    sendClevertapTrackerFailActivateRemainingNewOutlets
  );
}

export function* fetchEwallet() {
  const responsePaymentMethod = yield call(
    apiPaymentMethod.getAllPaymentMethods
  );
  const paymentMethodsOutlet: any[] = [];
  responsePaymentMethod.data.forEach((p) => {
    paymentMethodsOutlet.push(p.outlet_statuses);
  });
  const paymentMethodTotalNumber = paymentMethodsOutlet.filter((value) => {
    return value !== null;
  }).length;
  try {
    yield put(
      actPaymentMethod.sethasActivatedEwallet(paymentMethodTotalNumber > 0)
    );
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error(e);
  }
}

export function* sendClevertapTrackerOnClickActivatePaymentMethodNotification() {
  try {
    const userData = yield call(fetchUserData);
    if (userData)
      clevertapSettingsPaymentMethod.activateInNotificationPaymentMethod(
        userData
      );
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(error);
  }
}

export function* sendClevertapTrackerOnClickDismissPaymentMethodNotification() {
  try {
    const userData = yield call(fetchUserData);
    if (userData)
      clevertapSettingsPaymentMethod.dismissInNotificationPaymentMethod(
        userData
      );
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(error);
  }
}

export default function* paymentMethodSaga() {
  yield takeLatest(FETCH_EWALLET, fetchEwallet);
  yield takeLatest(SETTING_PAYMENT_METHODS_PAGE_REQUEST, pageRequestFlow);
  yield takeLatest(
    SETTING_PAYMENT_METHODS_ON_CLICK_ACTIVATE_BUTTON,
    onClickActivateButtonFlow
  );
  yield takeLatest(
    SETTING_PAYMENT_METHODS_ON_CLICK_CANCEL_REGISTRATION,
    onClickCancelRegistrationFlow
  );
  yield takeLatest(
    SETTING_PAYMENT_METHODS_ON_CLICK_SUBMIT_E_WALLET_PAYMENT,
    onClickSubmitEWalletPaymentFlow
  );
  yield takeLatest(
    SETTING_PAYMENT_METHODS_ON_CLICK_SHOW_OUTLET_DETAIL_MODAL,
    onClickShowOutDetailModalFlow
  );
  yield takeLatest(
    SETTING_PAYMENT_METHODS_ON_CLICK_SHOW_TERMS_AND_CONDITIONS_MODAL,
    onClickTermsAndConditionsFlow
  );
  yield takeLatest(
    SETTING_PAYMENT_METHODS_ON_CLICK_ACTIVATE_ALL,
    onClickActivateAllFlow
  );
  yield takeLatest(SETTING_PAYMENT_METHODS_UPDATE_KTP_NPWP, updateKtpNpwpFlow);
  yield takeLatest(
    SETTING_PAYMENT_METHODS_ON_CLICK_ADD_BANK_ACCOUNT,
    onClickAddBankAccountFlow
  );
  yield takeLatest(
    SETTING_PAYMENT_METHODS_ON_CLICK_ADD_BANK_ACCOUNT_OPEN_BANK_ACCOUNT_MODAL,
    onClickAddBankAccountOpenBankAccountModalFormFlow
  );
  yield takeLatest(
    SETTING_PAYMENT_METHODS_ON_CLICK_OUTLET_TO_BANK_ACCOUNT,
    linkOutletToBankAccount
  );
  yield takeLatest(
    SETTING_PAYMENT_METHODS_ON_CLICK_ACTIVATE_PAYMENT_METHOD_IN_NOTIFICATION,
    sendClevertapTrackerOnClickActivatePaymentMethodNotification
  );
  yield takeLatest(
    SETTING_PAYMENT_METHODS_ON_CLICK_DISMISS_PAYMENT_METHOD_IN_NOTIFICATION,
    sendClevertapTrackerOnClickDismissPaymentMethodNotification
  );
  yield takeLatest(
    SETTING_PAYMENT_METHODS_ACTIVATE_ALL_PAYMENT_METHOD,
    activateAllPaymentMethod
  );
  yield takeLatest(
    SETTING_PAYMENT_METHODS_REMAINING_PAYMENT_METHOD,
    activateRemainingPaymentMethod
  );
  yield takeLatest(
    SETTING_PAYMENT_METHODS_REMAINING_NEW_OUTLET,
    activateRemainingNewOutlet
  );
}
